/**
 * CSS color composition primitives for token-bound monograph panels.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

const HEX_ALPHA_MAX = 255;

function alphaPercent(alphaHex: string): number {
  const parsed = Number.parseInt(alphaHex, 16);
  const alpha = Number.isFinite(parsed)
    ? Math.min(Math.max(parsed, 0), HEX_ALPHA_MAX)
    : HEX_ALPHA_MAX;
  return Math.round((alpha / HEX_ALPHA_MAX) * 1000) / 10;
}

export function colorWithAlpha(color: string, alphaHex: string): string {
  return `color-mix(in srgb, ${color} ${alphaPercent(alphaHex)}%, transparent)`;
}

export function colorGradientToAlpha(color: string, alphaHex: string): string {
  return `linear-gradient(90deg, ${color}, ${colorWithAlpha(color, alphaHex)})`;
}
